import { AgentData } from '@core/models/agent-data.model';
import { Config } from '@core/models/config.model';
import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import * as reducers from './reducers';
import { LifePlanState, PredictionsState } from './reducers';
import { FinancialInfo } from './reducers/financial-info.reducer';
import { RetirementInfo } from './reducers/retirement-info.reducer';
import { RatingsState } from './reducers/ratings.reducer';
import { RecommendedProductsState } from './reducers/recommended-products.reducer';
import { ClientData } from '@core/models/client-data.model';

export interface AppState {
  config: Config;
  lifePlan: LifePlanState;
  recommendedProducts: RecommendedProductsState;
  ratings: RatingsState;
  predictions: PredictionsState;
  financialInfo: FinancialInfo;
  retirementInfo: RetirementInfo,
  agentData: AgentData;
  clientData: ClientData;
}
export const appReducers: ActionReducerMap<AppState> = {
  config: reducers.configReducer,
  lifePlan: reducers.lifePlanReducer,
  recommendedProducts: reducers.recommendedProductsReducer,
  ratings: reducers.ratingsReducer,
  predictions: reducers.predictionsReducer,
  financialInfo: reducers.financialInfoReducer,
  retirementInfo: reducers.retirementInfoReducer,
  agentData: reducers.agentDataReducer,
  clientData: reducers.clientDataReducer
};
export const metaReducers: MetaReducer<AppState>[] = [];
